export const colorsData = [
  { color: "#f2f7fc" },
  { color: "#ffbfca" },
  { color: "#8be5f5" },
  { color: "#f9f9c0" },
  { color: "#e18d8d" },
  { color: "#cf8fcf" },
  { color: "#8ce68c" },
];
